import React from 'react'
import { useCallback, useState } from 'sb-hooks'
import type { AddToProps } from 'components/_new/controls/addTo/util/types'


type UseAddToButtonProps = {
  props: AddToProps<any, any>
  action: (props: AddToProps<any, any>) => Promise<any>
  onAdd: (props: AddToProps<any, any>) => void
}

const useAddToButton = ({ props, action, onAdd }: UseAddToButtonProps) => {
  const [ isFetching, setFetching ] = useState<boolean>(false)

  const handleClick = useCallback((event: React.MouseEvent) => {
    const { product, metadata, disabled, onBeforeAdd, onAfterAdd, onClick } = props

    event.preventDefault()
    event.stopPropagation()

    if (isFetching || disabled) {
      return
    }

    setFetching(true)

    if (typeof onBeforeAdd === 'function') {
      onBeforeAdd(product, metadata)
    }

    if (typeof onAdd === 'function') {
      onAdd(props)
    }

    if (typeof onClick === 'function') {
      onClick(event)
    }

    if (typeof action === 'function') {
      action(props)
        .finally(() => setFetching(false))
        .then((result) => {
          if (typeof onAfterAdd === 'function') {
            onAfterAdd(product, metadata, Boolean(result))
          }
        })
    }
    else {
      setFetching(false)
    }
  }, [ isFetching, props, action, onAdd ])

  return {
    isFetching,
    handleClick,
  }
}


export default useAddToButton
